import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {createSelector} from 'reselect';

import * as styles from '../../styles';
import PaginatedContainer from '../../paginator/paginated_container';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh, clearSelection, updateItem} from '../../paginator/actions';
import booksFiltersSelectorGenerator from '../books/filters';


export default class BookStoreItems extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {
            field: item => `${item.item_object.title} (${item.item_object.id.persian()})`,
            label: window.gettext('Title'),
        },
        {field: item => item.item_object.grade ? item.item_object.grade.title : '-', label: window.gettext('Grade')},
        {field: 'price', label: window.gettext('Price')},
        {field: 'weight', label: window.gettext('Weight')},
        {
            field: item => item.off ? <span style={{color: 'red'}}>{'%' + item.off.persian()}</span> : null,
            label: window.gettext('Off'),
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.supply_in_store
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.supply_in_store
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.supply_in_store
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '2em',
                }}
                className={item.supply_in_store ? 'fa-check' : 'fa-times'}>
            </div>,
            label: window.gettext('Supply in store'),
        },
        {
            field: item => <span style={{display: 'inline-block', width: '10em'}}>
                <span style={{display: 'inline-block', width: '3.5em', textAlign: 'center'}}>
                    {item.stock.persian()}
                </span>
                &nbsp;
                <button
                    style={{
                        ...styles.button,
                        backgroundColor: 'transparent',
                        padding: '.5em',
                        boxSizing: 'border-box',
                        minWidth: undefined,
                    }}
                    onClick={async event => {
                        event.stopPropagation();
                        const amount = prompt(window.gettext('Enter amount to increase:')).english();
                        if (String(Number(amount)) !== amount)
                            return;
                        const response = await this.context.store.dispatch(request({
                            path: `/store-item/${item.id}/increase_stock/`,
                            body: {amount},
                            method: 'PATCH',
                        }));
                        this.context.store.dispatch(updateItem(response, this.props.store.getIn(['paginator', 'elementId'])));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    <i className='fa-plus fa-lg'></i>
                </button>
                <button
                    style={{
                        ...styles.button,
                        backgroundColor: 'transparent',
                        padding: '.5em',
                        boxSizing: 'border-box',
                        minWidth: undefined,
                    }}
                    onClick={async event => {
                        event.stopPropagation();
                        const amount = prompt(window.gettext('Enter amount to increase:')).english();
                        if (String(Number(amount)) !== amount)
                            return;
                        const response = await this.context.store.dispatch(request({
                            path: `/store-item/${item.id}/increase_stock/`,
                            body: {amount: -Number(amount)},
                            method: 'PATCH',
                        }));
                        this.context.store.dispatch(updateItem(response, this.props.store.getIn(['paginator', 'elementId'])));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    <i className='fa-minus fa-lg'></i>
                </button>
            </span>,
            label: <span style={{display: 'inline-block', width: '10em', textAlign: 'center'}}>{window.gettext('Stock')}</span>,
        },
        {field: 'sold', label: window.gettext('Sold')},
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}
                onClick={async event => {
                    event.stopPropagation();
                    this.context.store.dispatch(push('/store/orders/?item=' + item.id));
                }}
                onMouseUp={({target}) => target.blur()}>
                {window.gettext('Sell Report')}
            </button>
            ,
        },
    ]

    booksFiltersSelector = booksFiltersSelectorGenerator.bind(this)('book__')

    filtersSelector = createSelector.bind(this)(
        [
            store => this.booksFiltersSelector(store),
        ],
        booksFilters => [
            {
                field: 'type',
                selected: {'book': null},
            },
            ...booksFilters,
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('id'), reversed: true},
        {name: 'grade', label: window.gettext('Grade')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(
                    this.props.actions,
                    [
                        {
                            label: window.gettext('Supply in store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna supply these %(count)s items in store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': true})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                        {
                            label: window.gettext('Remove from store'),
                            action: async () => {
                                if (!window.confirm(window.interpolate(
                                    window.gettext('Are you sure you wanna remove these %(count)s items from store?'),
                                    {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                    true,
                                )))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/store-item/',
                                    body: this.props.store.getIn(
                                        ['paginator', 'selected'],
                                    ).map((comment, id) => ({id, 'supply_in_store': false})).toArray(),
                                    method: 'PATCH',
                                }));
                                this.context.store.dispatch([
                                    clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                ]);
                            },
                        },
                    ],
                )
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='store-item'
            title={window.gettext('Book Store Items')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
        />;
    }
}
